import { observable } from 'mobx';
import moment from '@this/lib/moment';

export type RoomElementResponseArgs = {
  id: number;
  name: string;
  started_at: string;
  ended_at: string;
};

export type RoomElementArgs = {
  id: number;
  name: string;
  startedAt: moment.Moment;
  endedAt: moment.Moment;
};

export const convertRoomElementResponseToArgs = (response: RoomElementResponseArgs) => {
  const args: RoomElementArgs = {
    id: response.id,
    name: response.name,
    startedAt: moment(response.started_at),
    endedAt: response.ended_at ? moment(response.ended_at) : moment(response.started_at).add(1, 'hour')
  };
  return args;
};

export default class RoomElement {
  @observable id: number;
  @observable name: string;

  @observable
  startedAt: moment.Moment;

  @observable
  endedAt: moment.Moment;

  constructor(args: RoomElementArgs) {
    this.id = args.id;
    this.name = args.name;
    this.startedAt = args.startedAt;
    this.endedAt = args.endedAt;
  }

  get type() {
    return 'room';
  }

  get startDate() {
    return this.startedAt;
  }

  get endDate() {
    return this.endedAt;
  }

  get title() {
    return '会議室';
  }

  get summary() {
    return `[会議室]${this.name}`;
  }

  get mappingDescription() {
    return this.title;
  }

  detail() {
    return '';
  }
}
